import React, { useEffect } from "react";

import { CProgress } from "@coreui/react";

import URL from "../../../config/api";
import getStudentsData from "../DataFromBackend/StudentsData";

import "./styles.scss";

/* `selectable` e as props de seleção são opcionais: sem elas a tabela é a de
   sempre, sem coluna de marcação. Quem as passa é o relatório da atividade em
   /activity/list, que leva os estudantes marcados para a alocação das
   atividades sugeridas — o estado da seleção mora lá, porque a seção das
   sugestões é irmã desta tabela. */
const AtividadeTurma = ({
  applications,
  executions,
  selectable,
  selectedUserIds = [],
  onToggleUser,
  onChangeSelection
}) => {
  useEffect(() => {}, []);

  if (!executions || !applications) {
    return <span>Carregando...</span>;
  }

  const trulyExecutions = executions.executions.filter(
    execution => execution.completion_percentage >= 100
  );
  const trulyApplications = getStudentsData(applications);

  /* `users` chega como array na maioria dos casos, mas o backend monta a lista
     com as chaves preservadas — quando elas não são sequenciais o JSON vira
     objeto. Object.values cobre os dois, como o corpo da tabela já faz. */
  const studentIds = Object.values(executions.users || {}).map(
    user => user.user_id
  );
  const allSelected =
    studentIds.length > 0 && selectedUserIds.length >= studentIds.length;

  return (
    <>
      {selectable && (
        <div className="d-flex align-items-center justify-content-between w-100 mb-2">
          <small className="text-muted">
            {selectedUserIds.length
              ? `${selectedUserIds.length} de ${studentIds.length} estudante(s) selecionado(s)`
              : "Nenhum estudante selecionado"}
          </small>
          <button
            type="button"
            className="btn btn-secondary btn-sm"
            onClick={() =>
              onChangeSelection(selectedUserIds.length ? [] : studentIds)
            }
          >
            {selectedUserIds.length ? "Desmarcar todos" : "Selecionar todos"}
          </button>
        </div>
      )}
      <div className="layoutTabela">
        <table className="table table-hover table-outline mb-0 d-none d-sm-table">
          <thead className="thead-light">
            <tr>
              {selectable && (
                <th style={{ width: "40px" }}>
                  <input
                    type="checkbox"
                    checked={allSelected}
                    title={allSelected ? "Desmarcar todos" : "Selecionar todos"}
                    onChange={() =>
                      onChangeSelection(allSelected ? [] : studentIds)
                    }
                  />
                </th>
              )}
              <th>Estudante</th>
              <th>% Conclusão</th>
              <th>Nota</th>
            </tr>
          </thead>
          {executions && (
            <tbody>
              {Object.values(executions.users)?.map(user => {
                const execution = executions.executions.find(
                  execution => execution.user_id === user.user_id
                );

                const percentage =
                  execution?.completion_percentage.toFixed(2) || "0.00";
                const grade =
                  execution && execution.grade
                    ? Number(execution.grade).toFixed(2)
                    : "";

                return (
                  /* A linha inteira marca o estudante — a caixinha é pequena
                     demais para ser o único alvo. O clique na própria caixinha
                     para de propagar, senão ele contaria duas vezes e a
                     seleção não mudaria. */
                  <tr
                    key={user.user_id}
                    onClick={
                      selectable ? () => onToggleUser(user.user_id) : undefined
                    }
                    style={selectable ? { cursor: "pointer" } : undefined}
                  >
                    {selectable && (
                      <td>
                        <input
                          type="checkbox"
                          checked={selectedUserIds.includes(user.user_id)}
                          onClick={event => event.stopPropagation()}
                          onChange={() => onToggleUser(user.user_id)}
                        />
                      </td>
                    )}
                    <td>
                      <div className="d-flex align-items-center">
                        <div className="c-avatar mr-3">
                          <img
                            src={
                              URL.img +
                              (user.user_photo ||
                                "uploads/users/profileEmpty.jpg")
                            }
                            className="c-avatar-img"
                            alt="imagem"
                          />
                        </div>
                        {user.user_name}
                      </div>
                    </td>
                    <td>
                      <div className="clearfix">
                        <div className="float-left">
                          <strong>{percentage}%</strong>
                        </div>
                      </div>
                      <CProgress
                        className="progress-xs"
                        color={
                          percentage > 50
                            ? "success"
                            : percentage <= 50 && percentage >= 30
                            ? "warning"
                            : "danger"
                        }
                        value={percentage}
                      />
                    </td>
                    <td>{grade}</td>
                  </tr>
                );
              })}
            </tbody>
          )}
        </table>
      </div>

      {/* <div className="layoutTabela" style={{ marginTop: "20px" }}>
        <CRow>
          <CCol>
            <CCard>
              <CCardBody>
                <CDataTable
                  items={[
                    {
                      Total: executions.users.length,
                      Concluido: `${
                        (trulyExecutions.length / executions.users.length) * 100
                      }%`,
                      Menor: `${
                        applications.length > 0
                          ? trulyApplications
                              .reduce(
                                (acc, val) =>
                                  Math.min(acc, parseFloat(val.nota)),
                                10000
                              )
                              .toFixed(2)
                          : ""
                      }`,
                      Maior: `${
                        applications.length > 0
                          ? trulyApplications
                              .reduce(
                                (acc, val) =>
                                  Math.max(acc, parseFloat(val.nota)),
                                0
                              )
                              .toFixed(2)
                          : ""
                      }`,
                      Media: `${
                        applications.length > 0
                          ? (
                              trulyApplications.reduce(
                                (acc, val) => acc + parseFloat(val.nota),
                                0
                              ) / trulyApplications.length
                            ).toFixed(2)
                          : ""
                      }`,
                    },
                  ]}
                  fields={["Total", "Concluido", "Menor", "Maior", "Media"]}
                  hover
                  striped
                  bordered
                  size="sm"
                  itemsPerPage={10}
                  pagination
                />
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </div> */}
      <div className="layoutTabela mt-4">
        <table className="table table-hover table-outline mb-0 d-none d-sm-table">
          <thead className="thead-light">
            <tr>
              <th>Estudantes</th>
              <th>Quantos concluíram</th>
              <th>% Conclusão</th>

              <th>Maior nota</th>
              <th>Menor nota</th>
              <th>Média</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{executions.users.length}</td>
              <td>{trulyExecutions.length}</td>
              <td>
                <div className="clearfix">
                  <div className="float-left">
                    <strong>
                      {(
                        (trulyExecutions.length / executions.users.length) *
                          100 || 0
                      ).toFixed(2)}
                      %
                    </strong>
                  </div>
                </div>
                <CProgress
                  className="progress-xs"
                  color="success"
                  value={
                    (trulyExecutions.length / executions.users.length || 0) *
                    100
                  }
                />
              </td>
              <td>
                {applications.length > 0
                  ? trulyApplications
                      .reduce(
                        (acc, val) => Math.max(acc, parseFloat(val.nota)),
                        0
                      )
                      .toFixed(2)
                  : ""}
              </td>
              <td>
                {applications.length > 0
                  ? trulyApplications
                      .reduce(
                        (acc, val) => Math.min(acc, parseFloat(val.nota)),
                        10000
                      )
                      .toFixed(2)
                  : ""}
              </td>
              <td>
                {applications.length > 0
                  ? (
                      trulyApplications.reduce(
                        (acc, val) => acc + parseFloat(val.nota),
                        0
                      ) / trulyApplications.length
                    ).toFixed(2)
                  : ""}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default AtividadeTurma;
